import React from 'react';
import { PageHeader, Button } from '../../components/shared';
import styles from './Benefits.scss';
import { clientInfoContext } from '../../contexts/ClientInfoContext';
import avatar from '../../images/avatar.jpg';

const images = require.context('../../images/reps', true);
const icons = require.context('../../images/icons/benefits', true);
const iconsHover = require.context('../../images/icons/benefits/hover', true);

const Benefits = props => {
  const { client } = props;
  const { suiteName, companyName, suiteType, suiteClient, repInfo } = client;
  console.log('🚀 ~ suiteType:', suiteType);
  const benefitsData = [
    {
      link: 'https://www.vikings.com/fans/viking-lakes/northern-lights-package',
      icon: './accomodation.svg',
      text: 'Viking Omni Lakes Northern Lights Accommodation',
    },
    // {
    //   link: '#',
    //   icon: './field-pass.svg',
    //   text: 'Field Pass Preferences',
    // },
    {
      link:
        'https://minnesotavikings.formstack.com/forms/legends_visit_request_form',
      icon: './legend.svg',
      text: 'Request a Vikings Legend visit for your suite',
    },
    {
      link: 'https://vikingsmobileshop.com/',
      icon: './store.svg',
      text: 'Exclusive Game Day Preorder Merchandise',
    },
    {
      link:
        'https://minnesotavikings.formstack.com/forms/mvc_suite_visit_request',
      icon: './cheer.svg',
      text: 'Request a Vikings Cheerleader visit for your suite',
    },
    {
      link:
        'https://minnesotavikings.formstack.com/forms/vikings_table_event_request',
      icon: './food-truck.svg',
      text: 'Vikings Food Truck',
    },
    // {
    //   link:
    //     'https://minnesotavikings.formstack.com/forms/post_game_field_photo_requests',
    //   icon: './photos.svg',
    //   text: 'Request Post Game Field Photos',
    // },
    {
      link: 'https://totallimo.com/',
      icon: './transportation.svg',
      text: 'Luxury Game Day Transportation: Total Transportation',
    },
  ];
  const repAvatar = (() => {
    if (!repInfo || !repInfo.rep_name) {
      return './default.jpg';
    }
    switch (repInfo.rep_name) {
      case 'Vanessa Reid':
        return './rep1.jpg';
      case 'Austin Hansen':
        return './rep2.jpg';
      case 'Chrissy Van Allen':
        return './rep3.jpg';
      default:
        return '';
    }
  })();

  if (!client || Object.keys(client).length === 0)
    return (
      <div className={styles.benefits}>
        <div className={styles.benefits__content}>
          <h1 style={{ textAlign: 'center', marginTop: '100px' }}>
            No purl found
          </h1>
        </div>
      </div>
    );
  return (
    <div className={styles.benefits}>
      <PageHeader title="Norseman Gold Members" />
      <div className={styles.benefits__content}>
        <div className={styles.benefits__header}>
          <div className={styles.benefits__header__left}>
            {/* <div className={styles.client_avatar}>
              <img src={avatar} alt="" />
            </div> */}
            <h2 className={styles.welcome__text}>{suiteClient?.client_name}</h2>
            <span className={styles.label}>
              {suiteClient?.client_job_title}
            </span>
            <span className={styles.client_email}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <g clipPath="url(#clip0_15_7048)">
                  <path
                    d="M16.165 3.00002C16.0969 2.993 16.0282 2.993 15.96 3.00002H1.96001C1.87028 3.0014 1.78115 3.01485 1.69501 3.04002L8.92001 10.235L16.165 3.00002Z"
                    fill="#FEC326"
                  />
                  <path
                    d="M16.905 3.69501L9.62503 10.945C9.43766 11.1313 9.18421 11.2358 8.92003 11.2358C8.65584 11.2358 8.40239 11.1313 8.21503 10.945L1.00003 3.75001C0.977847 3.83153 0.966086 3.91553 0.965027 4.00001V14C0.965027 14.2652 1.07038 14.5196 1.25792 14.7071C1.44546 14.8947 1.69981 15 1.96503 15H15.965C16.2302 15 16.4846 14.8947 16.6721 14.7071C16.8597 14.5196 16.965 14.2652 16.965 14V4.00001C16.961 3.89583 16.9408 3.79293 16.905 3.69501ZM2.65003 14H1.95503V13.285L5.59003 9.68001L6.29503 10.385L2.65003 14ZM15.955 14H15.255L11.61 10.385L12.315 9.68001L15.95 13.285L15.955 14Z"
                    fill="#FEC326"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_15_7048">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              {suiteClient?.client_email}
            </span>
          </div>
          <div className={styles.benefits__header__right}>
            {/* <div className={styles.client_avatar}>
              <img src={avatar} alt="" />
            </div> */}
            <h2 className={styles.welcome__text}>
              {suiteClient?.client2_name}
            </h2>
            <span className={styles.label}>
              {suiteClient?.client2_job_title}
            </span>
            <span className={styles.client_email}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <g clipPath="url(#clip0_15_7048)">
                  <path
                    d="M16.165 3.00002C16.0969 2.993 16.0282 2.993 15.96 3.00002H1.96001C1.87028 3.0014 1.78115 3.01485 1.69501 3.04002L8.92001 10.235L16.165 3.00002Z"
                    fill="#FEC326"
                  />
                  <path
                    d="M16.905 3.69501L9.62503 10.945C9.43766 11.1313 9.18421 11.2358 8.92003 11.2358C8.65584 11.2358 8.40239 11.1313 8.21503 10.945L1.00003 3.75001C0.977847 3.83153 0.966086 3.91553 0.965027 4.00001V14C0.965027 14.2652 1.07038 14.5196 1.25792 14.7071C1.44546 14.8947 1.69981 15 1.96503 15H15.965C16.2302 15 16.4846 14.8947 16.6721 14.7071C16.8597 14.5196 16.965 14.2652 16.965 14V4.00001C16.961 3.89583 16.9408 3.79293 16.905 3.69501ZM2.65003 14H1.95503V13.285L5.59003 9.68001L6.29503 10.385L2.65003 14ZM15.955 14H15.255L11.61 10.385L12.315 9.68001L15.95 13.285L15.955 14Z"
                    fill="#FEC326"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_15_7048">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              {suiteClient?.client2_email}
            </span>
          </div>
        </div>
        <h2 className={styles.sub_title}>Your Benefits</h2>
        <div className={styles.benefits_boxes}>
          {benefitsData.map((benefit, index) => (
            <a
              className={styles.box}
              href={benefit.link}
              target="_blank"
              rel="noopener noreferrer"
              key={index}
            >
              <div className={styles.icon}>
                <img
                  className={styles.icon__default}
                  src={icons(benefit.icon)}
                  alt=""
                />
                <img
                  className={styles.icon__hover}
                  src={iconsHover(benefit.icon)}
                  alt=""
                />
              </div>
              <p>{benefit.text}</p>
              <svg
                className={styles.arrow}
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <g clipPath="url(#clip0_25_555)">
                  <path
                    d="M10 0L20 10L10 20L8.23286 18.2329L15.21 11.2271H0V8.77286H15.21L8.23286 1.76714L10 0Z"
                    fill="#4F2683"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_25_555">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default React.forwardRef((props, ref) => (
  <clientInfoContext.Consumer>
    {client => <Benefits {...props} client={client} ref={ref} />}
  </clientInfoContext.Consumer>
));
